import React from "react";
import Button from "./Button";

export default function Breadcrumb({
  items = [],
  separator = "|",
  onNavigate,
}) {
  return (
    <nav className="rm-breadcrumb" aria-label="Breadcrumb">
      <ol className="rm-breadcrumb__list">
        {items.map((it, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={it.id || it.label || idx} className="rm-breadcrumb__item">
              {isLast ? (
                <span
                  className="rm-breadcrumb__current rm-breadcrumb__label"
                  aria-current="page"
                  title={it.label}
                >
                  {it.label}
                </span>
              ) : (
                <Button
                  className="rm-breadcrumb__link btn-link"
                  label={it.label}
                  title={it.label}
                  onClick={() => onNavigate?.(it.id)}
                />
              )}
              {!isLast && (
                <span className="rm-breadcrumb__sep" aria-hidden>
                  {separator}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
